import * as React from "react";
const SvgJsonSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      fill="#DFE2E7"
      fillRule="evenodd"
      d="M5.99 8.933c2.655 3.619 5.253-1.01 5.249-3.795-.005-3.291-3.34-5.13-5.251-5.13C2.92.007 0 2.541 0 6.01 0 9.865 3.348 12 5.988 12c-.598-.086-2.588-.513-2.615-5.098-.018-3.1 1.012-4.34 2.61-3.794.036.013 1.764.694 1.764 2.92 0 2.218-1.757 2.904-1.757 2.904"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M5.987 3.105c-1.754-.605-3.903.841-3.903 3.737C2.084 11.571 5.588 12 6.013 12 9.08 12 12 9.465 12 5.997 12 2.143 8.652.007 6.013.007c.73-.1 3.94.792 3.94 5.178 0 2.86-2.396 4.418-3.955 3.753-.036-.014-1.763-.695-1.763-2.922 0-2.217 1.752-2.91 1.752-2.91"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgJsonSvg;
